import { convertToDefaultDateFormat } from "@/util"

export default class FormattedTextExam {
  constructor(exam) {
    this.exam = exam
  }

  convert() {
    return {
      ...this.exam,
      text: `${this.exam.location} ${convertToDefaultDateFormat(this.exam.date)} ${this.exam.timeFrom} - ${this.exam.timeTo}`
    }
  }
}